
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AcceptProtocol',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible', 'confirm', 'openUserProtocol', 'openPrivacyProtocol'],
  setup(_props, { emit }) {
    const cancel = () => {
      emit('update:visible', false)
    }

    const confirm = () => {
      emit('confirm')
    }

    const openUserProtocol = () => {
      emit('openUserProtocol')
    }

    const openPrivacyProtocol = () => {
      emit('openPrivacyProtocol')
    }

    return {
      cancel,
      confirm,
      openUserProtocol,
      openPrivacyProtocol
    }
  }
})
